import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'validatorname',
  standalone: true
})
export class ValidatorNamePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    let retorno = value;
    environment.validadores.forEach(element => {
      console.log(`**** comparando ${element.address} con ${value}`)
      if (element.address.toLowerCase() == value.toLowerCase()){
        retorno += " - " + element.nombre;
      }
    });
    return retorno;

  }

}
